// extracted by mini-css-extract-plugin
export default {"small_contact":"Small_contact_small_contact__utwRm"};